import { Modal } from "@/shared/ui/modal"
import { closeDeletePartnerDiscountModal, fetchDeletePartnerDiscount, selectIsDeletePartnerDiscountModalOpen, selectOnDelete } from "../../model"
import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { SubmitHandler, useForm } from "react-hook-form"
import notify from "@/shared/lib/notify"
import { getErrorMessage } from "@/shared/consts/error-codes"

export const DeletePartnerDiscountModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectIsDeletePartnerDiscountModalOpen)
    const onDelete = useAppSelector(selectOnDelete)

    const handleClose = () => {
        dispatch(closeDeletePartnerDiscountModal())
    }

    const onSubmit: SubmitHandler<{}> = async () => {
        await new Promise((res, rej) => {
            dispatch(fetchDeletePartnerDiscount())
                .unwrap()
                .then(() => {
                    notify.success('Скидка успешно удалена')
                    reset()
                    res('')
                    onDelete?.()
                    handleClose()
                }).catch((e) => {
                    notify.error(getErrorMessage(e))
                    rej()
                })
        })
    }

    const {
        handleSubmit,
        reset,
        formState: {
            isSubmitting
        }
    } = useForm()

    return (
        <Modal
            isOpen={isOpen}
            title="Удаление скидки"
            onRequestClose={handleClose}
        >
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3">
                <div>
                    Вы уверены, что хотите удалить выбранную скидку?
                </div>
                <div className="w-full flex gap-3">
                    <button onClick={handleClose} className="form_cancel_button">
                        Отменить
                    </button>
                    <button disabled={isSubmitting} className="form_handle_button" type="submit">
                        Удалить
                    </button>
                </div>
            </form>
        </Modal>
    )
}